import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { signal } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { MojoFeatureExtensionsService } from 'mojo-feature-extensions';
import { AppFeatureExtensions } from '../../../app-feature-extensions.config';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PBINavBlockGuard {
  reports = signal(false);
  fullMenu = signal(false);
  isPBIReportsFEOn$: Observable<boolean> = this.mojoFeatureExtensionsService.hasFeatureExtension(
    AppFeatureExtensions.IRP_PBI_REPORT,
  );
  isReportsWithOtherMeanuFEOn$: Observable<boolean> =
    this.mojoFeatureExtensionsService.hasFeatureExtension(
      AppFeatureExtensions.PBI_REPORTS_WITH_OTHER_MENU_ITEMS,
    );

  constructor(
    private router: Router,
    private mojoFeatureExtensionsService: MojoFeatureExtensionsService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const url = state.url;

    return combineLatest([this.isPBIReportsFEOn$, this.isReportsWithOtherMeanuFEOn$]).pipe(
      map(([isPBIReportsFEOn, isReportsWithOtherMeanuFEOn]) => {
        if (!isPBIReportsFEOn && url.includes('/pbi-report')) {
          return false;
        }
        if (isPBIReportsFEOn && !isReportsWithOtherMeanuFEOn && !url.includes('pbi-report')) {
          console.warn('Blocked navigation to', url);
          return false;
        }
        return true;
      }),
    );
  }
}
